module.exports = __webpack_public_path__ + "static/media/building3.ae1f56ec.png";